import axios from "axios";
import type { UnknownAction } from "@reduxjs/toolkit";
import { setLicenceValidity } from "../reducers/licence";
import { store } from "../ProviderApp";
import { getBackendUrl } from "@Utils";
import { createAxiosWrapper, PlatformAdapter, ApiResponse } from "./axiosShared";
import { showToastNotification } from "../reducers/toastSlice";
import { untranslated } from "@Helpers/types/i18n";
import { TOAST_TYPE_ERROR } from "./constants";

const webAdapter: PlatformAdapter = {
  storage: {
    getItem: (key) => localStorage.getItem(key),
    removeItem: (key) => localStorage.removeItem(key),
  },
  navigation: {
    getCurrentPath: () => window.location.pathname,
    redirectToLogin: (params) => {
      const searchParams = new URLSearchParams();
      if (params?.redirectUrl) {
        searchParams.set("redirectUrl", encodeURIComponent(params.redirectUrl + window.location.search));
      }
      if (params?.errorMessage) {
        searchParams.set("errorMessage", encodeURIComponent(params.errorMessage));
      }
      window.location.href = `/?${searchParams.toString()}${window.location.hash}`;
    },
  },
  // The shared adapter declares `action` as `unknown` so mobile can plug its own store in; both
  // producers below return plain RTK action objects, hence the cast to `UnknownAction`.
  dispatch: (action) => store.dispatch(action as UnknownAction),
  actions: {
    setLoggedOut: () => ({ type: "LOGOUT" }),
    setLicenceInvalid: () => setLicenceValidity(false),
    showToast: (message) => showToastNotification({ content: untranslated(message), type: TOAST_TYPE_ERROR }),
  },
  excludedPathsFor401: ["/googleLoginCallback", "/95789", "/signup", "/thank-you", "/pdfExport", "/"],
  getBackendUrl: () => getBackendUrl() as string,
  isAuthenticated: () => Boolean(store.getState().checkIfAuthenticated?.data?.status),
};

const { instance, typedAxios } = createAxiosWrapper(webAdapter, axios);

export type { ApiResponse };
export { typedAxios };
// Raw axios instance (interceptors already attached). Exposed so lifecycle-aware wrappers such as
// useAbortableApi can delegate to it while re-declaring the TypedAxiosInstance surface for callers.
export const axiosInstance = instance;
export const axiosWrapper = typedAxios;
export default typedAxios;
